/**
 * studentCloseAccountViewModel — ce que « Fermer mon compte » lit dans le store : l'avis
 * d'abonnement encore valable (`DeleteAccountScreen.js`, PREMIUM ou PLUS seulement).
 *
 * Patron C (le compte est déjà là). Mémoïsé sur les rôles : le compte change d'identité à chaque
 * relecture, ses rôles presque jamais.
 */
import { createSelector } from "reselect"

import { closeAccountActiveOffer } from "../../../adapters/student/Account/studentPasswordAdapter"
import { selectAccount } from "../../shared/displayedStudent"

export type StudentCloseAccountViewModel = {
    activeOffer: string | null
}

// Le store est en JS non typé : on lit les champs qu'on connaît, sans le décrire en entier.
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReduxState = any

const selectRoles = (state: ReduxState): string[] | undefined => selectAccount(state)?.roles

export const studentCloseAccountViewModel = createSelector([selectRoles], (roles): StudentCloseAccountViewModel => ({
    activeOffer: closeAccountActiveOffer({ roles }),
}))
